export const INPUT_DEFAULT_PLACEHOLDER = 'Type...';

export const INPUT_DEFAULT_TEST_ID = 'input-field';

export const INPUT_DIRTY_DOT_PX = 4;
